import React, { useState } from "react";
import { useEyeconxStore } from "../../../store/eyeconxStore";
import { toAbsoluteUrl } from "../../helpers";
import { Link } from "react-router-dom";
import EcxOffcanvas from "./EcxOffcanvas";

function EcxHeader() {
  const sidebarBroken = useEyeconxStore((state) => state.sidebarBroken);
  const toggleSidebar = useEyeconxStore((state) => state.toggleSidebar);
  const user = useEyeconxStore((state) => state.user);

  const [userSidebar, setUserSidebar] = useState(false);

  const handleClose = () => {
    setUserSidebar(!userSidebar);
  };

  return (
    <header
      className={`d-flex align-items-center justify-content-between px-3 w-100 h-100 ${
        sidebarBroken ? "bg-dark text-white" : "bg-light"
      }`}
    >
      {/* Left section */}
      <div>
        {sidebarBroken ? (
          <button className="btn btn-outline-light" onClick={toggleSidebar}>
            <i className="bi bi-list fs-4"></i>
          </button>
        ) : (
          <div>
            <Link
              to="articles"
              className="btn btn-outline-secondary btn-sm me-2"
            >
              <i className="bi bi-book me-1"></i> Articles
            </Link>
            <Link
              to="eye-draw"
              className="btn btn-outline-secondary btn-sm me-2"
            >
              <i className="bi bi-easel me-1"></i> Eye Draw
            </Link>
            <Link
              to="messages"
              className="btn btn-outline-secondary btn-sm me-2"
            >
              <i className="bi bi-chat-right-text me-1"></i> Messages
            </Link>
          </div>
        )}
      </div>

      {/* Center section */}
      <div>
        {sidebarBroken && (
          <img
            src={toAbsoluteUrl("media/logos2/logo-light.png")}
            alt="Logo"
            height="35"
          />
        )}
      </div>

      {/* Right section */}
      <div>
        {sidebarBroken ? (
          <button className="btn btn-outline-light" onClick={handleClose}>
            <i className="bi bi-person-circle fs-4"></i>
          </button>
        ) : (
          <ul className="nav align-items-center">
            
            <li className="nav-item ms-3">
              <button
                className="btn btn-light btn-sm d-flex align-items-center"
                onClick={handleClose}
              >
                <span className="me-2">
                  Hi, {user && user.name ? user.name : "User"}
                </span>
                <i className="bi bi-person-circle"></i>
              </button>
            </li>
          </ul>
        )}
        <EcxOffcanvas show={userSidebar} handleClose={handleClose} />
      </div>
    </header>
  );
}

export default EcxHeader;
